import { Component, OnInit } from '@angular/core';
import {LanguageService} from '../service/language.service';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'app-terms-conditions',
    templateUrl: './terms-conditions.component.html',
    styleUrls: ['./terms-conditions.component.scss'],
    standalone: false
})
export class TermsConditionsComponent implements OnInit {

  // tslint:disable-next-line:variable-name
  constructor( private _language: LanguageService, private translate: TranslateService) {
    this._language.current_lang.subscribe(lang => {
      if (lang === 0 ) {
        translate.use('ro');
      } else {
        translate.use('en');
      }
    });
  }

  ngOnInit(): void {
  }

}
